/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateMeetingParticipantDto } from '../models/work-create-meeting-participant-dto';
import { WorkMeetingParticipant } from '../models/work-meeting-participant';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateMeetingParticipantDto } from '../models/work-update-meeting-participant-dto';

@Injectable({ providedIn: 'root' })
export class WorkMeetingParticipantsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `meetingParticipantsV2ControllerFindAllPaginated()` */
  static readonly MeetingParticipantsV2ControllerFindAllPaginatedPath = '/v2/meeting-participants';

  /**
   * Required permissions: meeting-participants:read, meeting-participants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingParticipantsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingParticipantsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 200
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by meetingId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingId=$not:$like:John Doe&filter.meetingId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingId'?: Array<string>;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by contactId query param.
     *           <p>
     *              <b>Format: </b> filter.contactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contactId=$not:$like:John Doe&filter.contactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.contactId'?: Array<string>;

    /**
     * Filter by role query param.
     *           <p>
     *              <b>Format: </b> filter.role={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.role=$not:$like:John Doe&filter.role=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.role'?: Array<string>;

    /**
     * Filter by attendanceStatus query param.
     *           <p>
     *              <b>Format: </b> filter.attendanceStatus={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.attendanceStatus=$not:$like:John Doe&filter.attendanceStatus=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.attendanceStatus'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingParticipant>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'role'?: (string | Array<string>);
'attendanceStatus'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingParticipantsV2Service.MeetingParticipantsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.meetingId', params['filter.meetingId'], {});
      rb.query('filter.userId', params['filter.userId'], {});
      rb.query('filter.contactId', params['filter.contactId'], {});
      rb.query('filter.role', params['filter.role'], {});
      rb.query('filter.attendanceStatus', params['filter.attendanceStatus'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkMeetingParticipant>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'meetingId'?: (string | Array<string>);
        'userId'?: (string | Array<string>);
        'contactId'?: (string | Array<string>);
        'role'?: (string | Array<string>);
        'attendanceStatus'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: meeting-participants:read, meeting-participants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingParticipantsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingParticipantsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 200
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by meetingId query param.
     *           <p>
     *              <b>Format: </b> filter.meetingId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.meetingId=$not:$like:John Doe&filter.meetingId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.meetingId'?: Array<string>;

    /**
     * Filter by userId query param.
     *           <p>
     *              <b>Format: </b> filter.userId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.userId=$not:$like:John Doe&filter.userId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.userId'?: Array<string>;

    /**
     * Filter by contactId query param.
     *           <p>
     *              <b>Format: </b> filter.contactId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.contactId=$not:$like:John Doe&filter.contactId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.contactId'?: Array<string>;

    /**
     * Filter by role query param.
     *           <p>
     *              <b>Format: </b> filter.role={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.role=$not:$like:John Doe&filter.role=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.role'?: Array<string>;

    /**
     * Filter by attendanceStatus query param.
     *           <p>
     *              <b>Format: </b> filter.attendanceStatus={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.attendanceStatus=$not:$like:John Doe&filter.attendanceStatus=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.attendanceStatus'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingParticipant>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'role'?: (string | Array<string>);
'attendanceStatus'?: (string | Array<string>);
};
};
}> {
    return this.meetingParticipantsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingParticipant>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'role'?: (string | Array<string>);
'attendanceStatus'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkMeetingParticipant>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'meetingId'?: (string | Array<string>);
'userId'?: (string | Array<string>);
'contactId'?: (string | Array<string>);
'role'?: (string | Array<string>);
'attendanceStatus'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `meetingParticipantsV2ControllerCreate()` */
  static readonly MeetingParticipantsV2ControllerCreatePath = '/v2/meeting-participants';

  /**
   * Required permissions: meeting-participants:create, meeting-participants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingParticipantsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingParticipantsV2ControllerCreate$Response(
    params: {
      body: WorkCreateMeetingParticipantDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingParticipant>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingParticipantsV2Service.MeetingParticipantsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingParticipant>;
      })
    );
  }

  /**
   * Required permissions: meeting-participants:create, meeting-participants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingParticipantsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingParticipantsV2ControllerCreate(
    params: {
      body: WorkCreateMeetingParticipantDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingParticipant> {
    return this.meetingParticipantsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingParticipant>): WorkMeetingParticipant => r.body)
    );
  }

  /** Path part for operation `meetingParticipantsV2ControllerFindOneById()` */
  static readonly MeetingParticipantsV2ControllerFindOneByIdPath = '/v2/meeting-participants/{id}';

  /**
   * Required permissions: meeting-participants:read, meeting-participants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingParticipantsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingParticipantsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingParticipant>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingParticipantsV2Service.MeetingParticipantsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingParticipant>;
      })
    );
  }

  /**
   * Required permissions: meeting-participants:read, meeting-participants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingParticipantsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingParticipantsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMeetingParticipant> {
    return this.meetingParticipantsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingParticipant>): WorkMeetingParticipant => r.body)
    );
  }

  /** Path part for operation `meetingParticipantsV2ControllerDelete()` */
  static readonly MeetingParticipantsV2ControllerDeletePath = '/v2/meeting-participants/{id}';

  /**
   * Required permissions: meeting-participants:delete, meeting-participants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingParticipantsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingParticipantsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingParticipantsV2Service.MeetingParticipantsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: meeting-participants:delete, meeting-participants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingParticipantsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  meetingParticipantsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.meetingParticipantsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `meetingParticipantsV2ControllerUpdate()` */
  static readonly MeetingParticipantsV2ControllerUpdatePath = '/v2/meeting-participants/{id}';

  /**
   * Required permissions: meeting-participants:update, meeting-participants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `meetingParticipantsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingParticipantsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateMeetingParticipantDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMeetingParticipant>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMeetingParticipantsV2Service.MeetingParticipantsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMeetingParticipant>;
      })
    );
  }

  /**
   * Required permissions: meeting-participants:update, meeting-participants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `meetingParticipantsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  meetingParticipantsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateMeetingParticipantDto
    },
    context?: HttpContext
  ): Observable<WorkMeetingParticipant> {
    return this.meetingParticipantsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMeetingParticipant>): WorkMeetingParticipant => r.body)
    );
  }

}
